import Inputmask from 'inputmask';

export const mask = () => {


    const numInputs = document.querySelectorAll('input[data-num]');
    const emailInputs = document.querySelectorAll('input[data-refuse-email]');

    document.addEventListener('DOMContentLoaded', () => {

        if(document.querySelectorAll('input[type="tel"]').length > 0) {
            let selector = document.querySelectorAll('input[type="tel"]');
            let im = new Inputmask('+7 (999) 999-99-99', {
            showMaskOnHover: false,
            });
            im.mask(selector);

            for (let el of selector ) {
                el.oninput = function() {
                    if ( el.value.replace(/[()+_ -]/g,'').length < 11 ) {
                        el.setCustomValidity("Заполните телефон полностью");
                    } else {
                        el.setCustomValidity("");
                    }
                }
            }

        }


        if(document.querySelectorAll('input[data-mask-bic]').length > 0) {
            let selector = document.querySelectorAll('input[data-mask-bic]');
            let bic = new Inputmask('999-999-999', {
            showMaskOnHover: false,
            });
            bic.mask(selector);

            for (let el of selector ) {
                el.oninput = function() {
                    if ( el.value.replace(/[^0-9]/g, "").length < 9 ) {
                        el.setCustomValidity(" ");
                    } else {
                        el.setCustomValidity("");
                    }
                }
            }

        }


        if(document.querySelectorAll('input[data-mask-bank]').length > 0) {
            let selector = document.querySelectorAll('input[data-mask-bank]');
            let bank = new Inputmask('999-99-999-9-9999-9999999', {
            showMaskOnHover: false,
            });
            bank.mask(selector);

            for (let el of selector ) {
                el.oninput = function() {
                    if ( el.value.replace(/[^0-9]/g, "").length < 20 ) {
                        el.setCustomValidity(" ");
                    } else {
                        el.setCustomValidity("");
                    }
                }
            }

        }

    })  


    if ( numInputs.length ) {
        for (let input of numInputs ) {
            input.oninput = function () {
                input.value = input.value.replace(/[^0-9]/g, "");
            }
        }
    }

    if ( emailInputs ) {
        for (let input of emailInputs ) {
            input.setCustomValidity(" ");
            input.oninput = function () {
                input.value = input.value.replace(/[^\a-zA-Z0-9@\.\-_]/g, "");
                

                if ( input.value.indexOf("@") > -1 && input.value.indexOf(".") > -1 && input.value.length > 3 ) {
                    input.setCustomValidity("");
                }

            }
        }
    }



}